import { render, staticRenderFns } from "./initialCourse.vue?vue&type=template&id=10b627d4&"
import script from "./initialCourse.vue?vue&type=script&lang=js&"
export * from "./initialCourse.vue?vue&type=script&lang=js&"
import style0 from "./initialCourse.vue?vue&type=style&index=0&id=10b627d4&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports